import React, { useState } from "react";

const helpData = [
  {
    category: "Compte",
    questions: [
      { q: "Comment créer un compte Kok Batay ?", a: "Allez sur la page d'inscription, remplissez le formulaire et validez votre email." },
      { q: "J'ai oublié mon mot de passe", a: "Utilisez le bouton 'Mot de passe oublié' sur la page de connexion." },
    ]
  },
  {
    category: "Paiement",
    questions: [
      { q: "Comment recharger mon solde ?", a: "Accédez à la section 'Mon profil' et choisissez 'Recharger' via les moyens de paiement disponibles." },
      { q: "Puis-je être remboursé ?", a: "Les remboursements sont possibles uniquement en cas de problème technique avéré." },
    ]
  },
  {
    category: "Jeu",
    questions: [
      { q: "Comment parier sur un combat ?", a: "Sélectionnez un combat, choisissez le coq et le montant de votre mise." },
      { q: "Les résultats sont-ils en direct ?", a: "Oui, les combats sont diffusés et mis à jour en temps réel." },
    ]
  }
];

const HelpCenter = () => {
  const [search, setSearch] = useState("");
  const [openQuestion, setOpenQuestion] = useState(null);

  const filteredData = helpData.map(cat => ({
    ...cat,
    questions: cat.questions.filter(
      q => q.q.toLowerCase().includes(search.toLowerCase()) || q.a.toLowerCase().includes(search.toLowerCase())
    )
  }));

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <h1 className="text-3xl font-bold text-center text-gray-900 mb-2">
          Centre d'aide Kok Batay
        </h1>
        <p className="text-center text-gray-600 mb-6">
          Trouvez rapidement des réponses à vos questions.
        </p>

        {/* Search bar */}
        <div className="mb-8">
          <input
            type="text"
            placeholder="Rechercher une question..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
          />
        </div>

        {/* FAQ categories */}
        {filteredData.map((cat, idx) => (
          <div key={idx} className="mb-8">
            <h2 className="text-xl font-semibold text-orange-600 mb-4">{cat.category}</h2>
            <div className="space-y-3">
              {cat.questions.length > 0 ? (
                cat.questions.map((item, i) => (
                  <div
                    key={i}
                    className="bg-white border border-gray-200 rounded-lg shadow-sm"
                  >
                    <button
                      onClick={() =>
                        setOpenQuestion(openQuestion === `${idx}-${i}` ? null : `${idx}-${i}`)
                      }
                      className="w-full flex justify-between items-center px-4 py-3 text-left"
                    >
                      <span className="font-medium text-gray-900">{item.q}</span>
                      <span className="text-orange-500 text-xl">
                        {openQuestion === `${idx}-${i}` ? "-" : "+"}
                      </span>
                    </button>
                    {openQuestion === `${idx}-${i}` && (
                      <div className="px-4 pb-3 text-gray-700">{item.a}</div>
                    )}
                  </div>
                ))
              ) : (
                <p className="text-gray-500">Aucune question trouvée dans cette catégorie.</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HelpCenter;
